"use client";

import { useQuery } from "@tanstack/react-query";

import type { PlanUsageDisplay } from "@/lib/billing/plan-usage";
import { clientFetch } from "@/lib/api/client-fetch";
import { STALE_TIME_PROFILE_MS } from "@/lib/react-query/defaults";
import { queryKeys } from "@/lib/react-query/query-keys";

export type PlanUsageSnapshot = PlanUsageDisplay & {
  noteSlotCount?: number;
};

type ApiSuccess<T> = { success: true; data: T };

export async function fetchPlanUsage(): Promise<PlanUsageSnapshot> {
  const res = await clientFetch("/api/plan/usage");
  if (!res.ok) throw new Error("Failed to load plan usage");
  const payload: ApiSuccess<PlanUsageSnapshot> = await res.json();
  return payload.data;
}

export function usePlanUsageQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.planUsage(),
    queryFn: fetchPlanUsage,
    staleTime: STALE_TIME_PROFILE_MS,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
}
